
   
    
    <div class="uk-child-width-1-1@s" uk-grid>
        <div>
            <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
                   style="background-image: url(../../assets/blog.png);">
                <div class="uk-section uk-light">
                    <div class="uk-container-small uk-width-2xlarge" style="padding-top: 55px;">
                        <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Websoullabs Blog</h1></div>
                        <div>
                            <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">We are always 
                                up-to-date with the latest and innovative technologies.
                                 When we started to write blogs, thought it might be useful to all out there.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="uk-section  uk-padding-large" style="padding-top: 40px;">
        
        <div class ="uk-container-small">
            <article class="uk-article">

                <h2  style="font-weight: 600px;"><b>Should you choose Graphic Design as a Carrier?</b></h2>
            
                <p class="uk-article-meta"><span uk-icon="icon:calendar; ratio: .8">   </span> 3 Jul 2020  <span uk-icon="icon:clock; ratio: .7"></span>   1 min read  <span uk-icon="icon:tag; ratio: .8"></span>  Graphic design</p>
                
                
                <img data-src="assets/blog8.jpg" width="874" height="340" alt="digital marketer" uk-img>

                <p class="uk-text-justify uk-text-medium" style="font-size:18px">Web Application Frameworks are sets of program libraries, components and tools organized in an architecture system allowing developers to build and maintain complex web application projects using a fast and efficient approach.</p>
                <div>
                    <button class="uk-button uk-button-secondary uk-align-left" style="margin-right: 0px;">Read more</button>
                        
                    
                    <div class="uk-align-right" style="margin-left: 0px;">
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    </div>
                </div>
            
            
            </article>
            <hr class="uk-divider-icon">
        </div>    
        <div class ="uk-container-small">
            <article class="uk-article">

                <h2  style="font-weight: 600px;"><b>How much will Mobile App Development cost in 2020?</b></h2>
            
                <p class="uk-article-meta"><span uk-icon="icon:calendar; ratio: .8">   </span>  3 Jul 2020 <span uk-icon="icon:clock; ratio: .7"></span>   1 min read  <span uk-icon="icon:tag; ratio: .8"></span>mobile app</p>
                <img data-src="assets/blog10.jpg" width="874" height="430" alt="digital marketer" uk-img>

                <p class="uk-text-justify uk-text-medium" style="font-size:18px">Web Application Frameworks are sets of program libraries, components and tools organized in an architecture system allowing developers to build and maintain complex web application projects using a fast and efficient approach.</p>
                <div>
                    <button class="uk-button uk-button-secondary uk-align-left" style="margin-right: 0px;">Read more</button>
                        
                    
                    <div class="uk-align-right" style="margin-left: 0px;">
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    </div>
                </div>
            
            </article>
            <hr class="uk-divider-icon">
        </div>    
        <div class ="uk-container-small">
            <article class="uk-article">

                <h2  style="font-weight: 600px;"><b>Developing Mobile and Web Based Application</b></h2>
            
                <p class="uk-article-meta"><span uk-icon="icon:calendar; ratio: .8">   </span>  3 Jul 2020  <span uk-icon="icon:clock; ratio: .7"></span>   1 min read  <span uk-icon="icon:tag; ratio: .8"></span>  php</p>
                <img data-src="assets/blog13.jpg" width="874" height="430" alt="digital marketer" uk-img>

                <p class="uk-text-justify uk-text-medium" style="font-size:18px">Web Application Frameworks are sets of program libraries, components and tools organized in an architecture system allowing developers to build and maintain complex web application projects using a fast and efficient approach.</p>
                <div>
                    <button class="uk-button uk-button-secondary uk-align-left" style="margin-right: 0px;">Read more</button>
                        
                    
                    <div class="uk-align-right" style="margin-left: 0px;">
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    </div>
                </div>
            
            </article>
            <hr class="uk-divider-icon">
        </div>    


        <div class ="uk-container-small">
            <article class="uk-article">

                <h2  style="font-weight: 600px;"><b>Life as a Digital Marketer</b></h2>
            
                <p class="uk-article-meta"><span uk-icon="icon:calendar; ratio: .8">   </span>  3 Jul 2020  <span uk-icon="icon:clock; ratio: .7"></span>   1 min read  <span uk-icon="icon:tag; ratio: .8"></span>  php</p>
                <img data-src="assets/blog2.jpg" width="874" height="430" alt="digital marketer" uk-img>

                <p class="uk-text-justify uk-text-medium" style="font-size:18px">Web Application Frameworks are sets of program libraries, components and tools organized in an architecture system allowing developers to build and maintain complex web application projects using a fast and efficient approach.</p>
                <div>
                    <button class="uk-button uk-button-secondary uk-align-left" style="margin-right: 0px;">Read more</button>
                        
                    
                    <div class="uk-align-right" style="margin-left: 0px;">
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    </div>
                </div>
            
            
            </article>
            <hr class="uk-divider-icon">
        </div>    
        <div class ="uk-container-small">
            <article class="uk-article">

                <h2  style="font-weight: 600px;"><b>Why Digital  Marketing is Important?</b></h2>
            
                <p class="uk-article-meta"><span uk-icon="icon:calendar; ratio: .8">   </span>  3 Jul 2020  <span uk-icon="icon:clock; ratio: .7"></span>   1 min read  <span uk-icon="icon:tag; ratio: .8"></span>  php</p>
                <img data-src="assets/blog4.jpg" width="874" height="430" alt="digital marketer" uk-img>

                <p class="uk-text-justify uk-text-medium" style="font-size:18px">Web Application Frameworks are sets of program libraries, components and tools organized in an architecture system allowing developers to build and maintain complex web application projects using a fast and efficient approach.</p>
                <div>
                    <button class="uk-button uk-button-secondary uk-align-left" style="margin-right: 0px;">Read more</button>
                        
                    
                    <div class="uk-align-right" style="margin-left: 0px;">
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    </div>
                </div>
            
            
            </article>
            <hr class="uk-divider-icon">
        </div>
        <div class ="uk-container-small">
            <article class="uk-article">

                <h2  style="font-weight: 600px;"><b>Team Work</b></h2>
            
                <p class="uk-article-meta"><span uk-icon="icon:calendar; ratio: .8">   </span>  3 Jul 2020  <span uk-icon="icon:clock; ratio: .7"></span>   1 min read  <span uk-icon="icon:tag; ratio: .8"></span>  php</p>
                <img data-src="assets/blog6.jpg" width="874" height="430" alt="team work" uk-img>

                <p class="uk-text-justify uk-text-medium" style="font-size:18px">Web Application Frameworks are sets of program libraries, components and tools organized in an architecture system allowing developers to build and maintain complex web application projects using a fast and efficient approach.</p>
                <div>
                    <button class="uk-button uk-button-secondary uk-align-left" style="margin-right: 0px;">Read more</button>
                        
                    
                    <div class="uk-align-right" style="margin-left: 0px;">
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    </div>
                </div>
            
            </article>
            <hr class="uk-divider-icon">
        </div>    
        <div class ="uk-container-small">
            <article class="uk-article">

                <h2  style="font-weight: 600px;"><b>Inhouse vs Outsourced Digital Marketing</b></h2>
            
                <p class="uk-article-meta"><span uk-icon="icon:calendar; ratio: .8">   </span>  3 Jul 2020  <span uk-icon="icon:clock; ratio: .7"></span>   1 min read  <span uk-icon="icon:tag; ratio: .8"></span>  php</p>
                <img data-src="assets/blog5.jpg" width="874" height="430" alt="digital marketer" uk-img>

                <p class="uk-text-justify uk-text-medium" style="font-size:18px">Web Application Frameworks are sets of program libraries, components and tools organized in an architecture system allowing developers to build and maintain complex web application projects using a fast and efficient approach.</p>
                <div>
                    <button class="uk-button uk-button-secondary uk-align-left" style="margin-right: 0px;">Read more</button>
                        
                    
                    <div class="uk-align-right" style="margin-left: 0px;">
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    </div>
                </div>
            
            </article>
            <hr class="uk-divider-icon">
        </div>    
        <div class ="uk-container-small">
            <article class="uk-article">

                <h2  style="font-weight: 600px;"><b> The roles of Graphic Design agencies in Marketing</b></h2>
            
                <p class="uk-article-meta"><span uk-icon="icon:calendar; ratio: .8">   </span>  3 Jul 2020 <span uk-icon="icon:clock; ratio: .7"></span>   1 min read  <span uk-icon="icon:tag; ratio: .8"></span>  php</p>
                <img data-src="assets/blog9.jpg" width="874" height="430" alt="digital marketer" uk-img>

                <p class="uk-text-justify uk-text-medium" style="font-size:18px">Web Application Frameworks are sets of program libraries, components and tools organized in an architecture system allowing developers to build and maintain complex web application projects using a fast and efficient approach.</p>
                <div>
                    <button class="uk-button uk-button-secondary uk-align-left" style="margin-right: 0px;">Read more</button>
                        
                    
                    <div class="uk-align-right" style="margin-left: 0px;">
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    </div>
                </div>
            
            </article>
            <hr class="uk-divider-icon">
        </div>    
        <div class ="uk-container-small">
            <article class="uk-article">

                <h2  style="font-weight: 600px;"><b>Latest trend in Mobile App Development</b></h2>
            
                <p class="uk-article-meta"><span uk-icon="icon:calendar; ratio: .8">   </span> 3 Jul 2020  <span uk-icon="icon:clock; ratio: .7"></span>   1 min read  <span uk-icon="icon:tag; ratio: .8"></span>  php</p>
                <img data-src="assets/blog11.jpg" width="874" height="430" alt="digital marketer" uk-img>

                <p class="uk-text-justify uk-text-medium" style="font-size:18px">Web Application Frameworks are sets of program libraries, components and tools organized in an architecture system allowing developers to build and maintain complex web application projects using a fast and efficient approach.</p>
                <div>
                    <button class="uk-button uk-button-secondary uk-align-left" style="margin-right: 0px;">Read more</button>
                        
                    
                    <div class="uk-align-right" style="margin-left: 0px;">
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    </div>
                </div>
            
            
            </article>
            <hr class="uk-divider-icon">
        </div>    
        <div class ="uk-container-small">
            <article class="uk-article">

                <h2  style="font-weight: 600px;"><b>Web Application Development</b></h2>
            
                <p class="uk-article-meta"><span uk-icon="icon:calendar; ratio: .8">   </span>  3 Jul 2020  <span uk-icon="icon:clock; ratio: .7"></span>   1 min read  <span uk-icon="icon:tag; ratio: .8"></span>  php</p>
                <img data-src="assets/blog12.jpg" width="874" height="430" alt="digital marketer" uk-img>

                <p class="uk-text-justify uk-text-medium" style="font-size:18px">Web Application Frameworks are sets of program libraries, components and tools organized in an architecture system allowing developers to build and maintain complex web application projects using a fast and efficient approach.</p>
                <div>
                    <button class="uk-button uk-button-secondary uk-align-left" style="margin-right: 0px;">Read more</button>
                        
                    
                    <div class="uk-align-right" style="margin-left: 0px;">
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                        <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    </div>
                </div>
            
            </article>
            <hr class="uk-divider-icon">
        </div>    

        
    </div>
